module.exports = __webpack_public_path__ + "static/media/logo.df925259.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 38
// module chunks = 0